import { Appointment } from "@/services/appointments/appointments";
import { formatDate } from "@/lib/date";

// Helper function to get the appropriate date to display for an appointment
export const getAppointmentDisplayDate = (appointment: Appointment): Date => {

   // For completed appointments without a scheduleDate, use updatedAt
   if(appointment.status === "completed" && !appointment.scheduleDate && appointment.updatedAt) {
     return new Date(appointment.updatedAt);
   }
 
   // For open appointments, use dueDate
   if (appointment.status === "open" && appointment.dueDate) {
     return new Date(appointment.dueDate);
   }
 
   // For all other cases, use scheduleDate if available
   if (appointment.scheduleDate) {
     return new Date(appointment.scheduleDate);
   }

   return new Date(NaN);
 };
 

// Helper function that returns a formatted date string
export const getFormattedAppointmentDate = (appointment: Appointment): string => {
  return formatDate(getAppointmentDisplayDate(appointment));
};